import "./Socials.css"
import { useNavigate } from 'react-router-dom';

import facebookLogo from "../../../assets/General/facebook-f.svg"
import mailLogo from "../../../assets/General/envelope-solid.svg"

const SocialButton = ({ image, type, ahref = null, onClick = null }) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  };

  if (ahref) {
    return (
      <button className="socials-button" onClick={handleClick}>
        <a href={ahref} rel="noopener noreferrer" target="_blank">
          <img className={`socials-logo ${type}`} src={image} alt={`${type} logo`} />
        </a>
      </button>
    );
  } else if (onClick) {
    return (
      <button className="socials-button" onClick={handleClick}>
        <img className={`socials-logo ${type}`} src={image} alt={`${type} logo`} />
      </button>
    );
  } else {
    return (
      <button className="socials-button">
        <img className={`socials-logo ${type}`} src={image} alt={`${type} logo`} />
      </button>
    );
  }
};

export default function Socials() {
  const navigate = useNavigate();
  return (
    <section className="socials-wrapper socials-drop-shadow">
      <SocialButton image={facebookLogo} type={'facebook'} ahref={'https://www.facebook.com/people/Flute-Alliance/100057682182115/'} />
      <SocialButton image={mailLogo} type={'mail'} onClick={() => navigate('/contact')} />
    </section>
  );
}
